import {Products} from '@freckle/educator-entities/ts/common/helpers/products'
import {Subjects} from '@freckle/educator-entities/ts/common/helpers/subjects'

export function urlToPathGroupingHash(urlString: string): string {
  const url = new URL(urlString)

  if (!url.hostname.includes('freckle.com')) return urlString

  const preserve = new Set<string>([
    ...Subjects.all().map(Subjects.asContentArea),
    ...Products.all().map(p => Products.getPaths(p).productPath)
  ])

  const normalized = url.pathname
    .split('/')
    .filter(Boolean)
    .map((segment, index) => {
      if (preserve.has(segment)) return segment

      // Preserve the first numeric segment (like /2/ or /3/)
      if (index === 0 && /^\d+$/.test(segment)) return segment

      if (/^\d+$/.test(segment)) return ':param'
      if (/^[0-9a-fA-F-]{11,}$/.test(segment)) return ':param'
      return segment
    })

  return `/${normalized.join('/')}`
}
